import { useContext } from 'react';
import { SetGoalContext } from './SetGoalProvider';

export const useSetGoalContext = () => {
  const context = useContext(SetGoalContext);

  if (context === undefined) {
    throw new Error('useSetGoalContext must be used within a SetGoalProvider');
  }

  return context;
};
